import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list"]
  connect(){
  }

  markCurrentHeading(event){
    const currentId = event.detail.currentHeadingId;
    this.listTargets.forEach(list => {
      list.querySelectorAll("a").forEach(link => {
        if (link.getAttribute("href") === `#${currentId}`) {
          link.querySelector("div").classList.add("bg-[#EBEBEB]");
        } else {
          link.querySelector("div").classList.remove("bg-[#EBEBEB]");
        }
      });
    });
  }

  addHeadings(event) {
    const { headings } = event.detail
    this.listTargets.forEach(list => {
      list.innerHTML = headings.map(h =>
        `<a href="#${h.id}">
          <div class="text-[14px] leading-[150%] p-[10px] hover:bg-[#EBEBEB]">${h.text}</div>
        </a>`
      ).join("")
    })
  }
}
